import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWN5MB (客訴單-採購經辦核准沖銷)
// backend/modules/pwn5mb/models/pwn5mb.go
// ============================================================

export interface EligibleItem {
  fn110_01: string;  // 客訴單號
  fn110_11: string;  // 客訴日期
  fn110_12: string;  // 客戶代號
  fn110_17: number;  // 客訴金額
  fn110_81: string;  // 採購經辦核准狀態 (P=已核准，本表單沖銷 P->N)
  fn110_22: string;  // 部門
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwn5mbApi = {
  /** Query complaint records eligible for purchase-handler approval reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<SearchResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start_no'] = startNo.trim();
    if (endNo.trim()) params['end_no'] = endNo.trim();
    const res = await apiClient.get('/api/pwn5mb/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected complaint records.
   * confirmed:true mirrors the Modal.confirm dialog the user already went
   * through (FoxPro PWU016F2 "請確認沖銷本資料!" dialog) — the backend
   * requires it (PWN5MB-VAL-EXECUTE-CONFIRM-DIALOG). */
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/pwn5mb/reverse', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
